import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import { ref, storage, query, where, db, collection, doc, setDoc, getDocs, deleteDoc, orderBy, serverTimestamp, uploadBytesResumable, getDownloadURL } from '../../config/firebaseConfig.js'; // Pastikan jalur benar
import { jwtDecode } from 'jwt-decode';
import Select from "react-select";
import Swal from "sweetalert2";
import "react-loading-skeleton/dist/skeleton.css";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // CSS bawaan tema


const Pengumuman = () => {
  const navigate = useNavigate();
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      ['clean'],
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'link', 'image'
  ];
  const akses = [
    { value: 'Semua', label: 'Semua' },
    { value: 'Pd', label: 'Peserta Didik' },
    { value: 'Pendidik', label: 'Pendidik / Guru' },
    { value: 'Operator', label: 'Operator' },

  ];
  const [formData, setFormData] = useState({
    akses: akses[0].value,
    isi: "",
    judul: "",
    subjudul: ""

  });


  const [isEditing, setIsEditing] = useState(false);

  const [refrashaktif, setRefrashaktif] = useState(true);

  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [progress, setProgress] = useState(0);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

const handleUpload = () => {
  if (!image) return;

  const decoded = jwtDecode(localStorage.getItem("authToken"));
  const storageRef = ref(storage, `pengumuman/${decoded.npsn}/${image.name}`);
  const uploadTask = uploadBytesResumable(storageRef, image);

  uploadTask.on(
    'state_changed',
    (snapshot) => {
      const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      setProgress(prog);
    },
    (error) => console.log(error),
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        setFormData((prev) => ({
          ...prev,
          img: downloadURL,
        }));
      });
    }
  );
};

  const handleChangeisi = (value) => {
    setFormData({
      ...formData, isi: value
    })
  };

 const getDataRefrensi = useCallback(async () => {


    try {
      // Kirim request ke server dengan header level user
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/getRefToJadwal`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch kelas");
      }

    } catch (error) {
      Swal.fire("Error!", error.message || 'Something went wrong', "error");
    }
  }, []);

  useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      console.error("Token required");
      return; // Jika tidak ada token, hentikan eksekusi
    }

    try {
      // Decode payload dari token JWT
    } catch (error) {
      console.error("Invalid token:", error);
      navigate('/login'); // Jika token tidak valid, arahkan ke halaman login
      return;
    }


  }, [navigate]);

  useEffect(() => {
  getDataRefrensi();

  const fetchData = async () => {
    const decoded = jwtDecode(localStorage.getItem("authToken"));

    if ($.fn.dataTable.isDataTable(".table")) {
      $(".table").DataTable().destroy();
    }

    let q = query(
      collection(db, "madding"),
      where("npsn", "==", decoded.npsn),
      orderBy("datetime", "desc")
    );

    setRefrashaktif(false);

    try {
      const ujianSnap = await getDocs(q);
      const ujianData2 = ujianSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      $(".table").DataTable({
        data: ujianData2,
        columns: [
          {
            data: null,
            orderable: false,
            className: "select-checkbox",
            render: (data, type, row, meta) =>
              `${meta.row + 1}`,
          },
          { data: null, render: (data) => `<b>${data.judul}</b> </br> ${data.subjudul}` },
          { data: null, render: (data) => `<b>${data.akses}</b>` },
          {
            data: null,
            render: (data, type, row) =>
              `
              <a data-bs-toggle="modal" data-bs-target="#ujianModal" class="edit-btn btn-link-secondary" data-row='${JSON.stringify(row)}' title="Ubah Data">
                <i class="ti ti-edit f-20"></i>
              </a>
              <a href="#" class="delete-btn btn-link-danger" data-id="${row.id}" title="Hapus">
                <i class="ti ti-trash f-20"></i>
              </a>
              `,
          },
        ],
        destroy: true,
        dom: "<'row'<'col-9'f><'col-3'B>><'row'<'col-12'tr>><'row'<'col-10'p><'col-2'i>>",
        language: {
          search: "",
          lengthMenu: "_MENU_",
          emptyTable: "Belum memiliki data",
          loadingRecords: "Loading....",
          zeroRecords: "Belum memiliki data",
        },
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  fetchData();

  return () => {
    if ($.fn.dataTable.isDataTable(".table")) {
      $(".table").DataTable().destroy();
    }
  };
}, [refrashaktif, getDataRefrensi]); // ✅ Tambahkan getDataRefrensi di sini



 




  $(document).off("click", ".edit-btn").on("click", ".edit-btn", function () {
    let rowData = $(this).data("row");
    console.log(rowData)
    if (rowData) {
      handleEdit(rowData);
    } else {
      console.error("Data tidak ditemukan.");
    }
  });
  // Event listener untuk tombol Delete menggunakan SweetAlert2
$(document).on("click", ".delete-btn", function (e) {
  e.preventDefault();
  let id = $(this).data("id"); // documentId dari Firestore

  Swal.fire({
    title: "Apakah Anda yakin?",
    text: "Data akan dihapus secara permanen!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Ya, hapus!",
    cancelButtonText: "Batal"
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        await deleteDoc(doc(db, "madding", id)); // misalnya dari koleksi "pengumuman"

        Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
         setRefrashaktif(true);
      } catch (error) {
        Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
        console.error("Delete error:", error);
      }
    }
  });
});

  // Handle perubahan input form
  const handleChange = (e) => {
    const { name, value } = e.target;
    let selectedText = "";
    if (name === "kode" || name === "data_id") {
      selectedText = e.target.options[e.target.selectedIndex].text;
    }


    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === "kode" && { nama_ujian: selectedText }),
      ...(name === "data_id" && { nama_guru: selectedText })
    }));
    console.log(formData)
  };



  // Buka modal untuk edit data
  const handleEdit = (ujian) => {
    setIsEditing(true);
    setFormData(ujian);
  };

 
  const handleSubmit = async (e) => {
    e.preventDefault();
let kodeid = null;

    // Fungsi membuat kode unik
    const generateRandomCode = () =>
      (Date.now().toString(36) + Math.random().toString(36).substring(2, 3)).toUpperCase();
    if (!formData.id) {
      kodeid = generateRandomCode(); // misalnya untuk data baru
    } else {
      kodeid = formData.id; // misalnya untuk data yang sudah ada
    }

    // ✅ Cek jika URL kosong
    if (!formData.img) {
      Swal.fire("Gagal!", "Silakan unggah gambar terlebih dahulu.", "warning");
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
      if (!token) throw new Error("Token tidak ditemukan");

      const decoded = jwtDecode(token);

      const newData = {
        ...formData,
        npsn: decoded.npsn,
        datetime: serverTimestamp()
      };

      // Simpan ke Firestore
      await setDoc(doc(db, "madding", kodeid), newData);

      // Notifikasi sukses
      Swal.fire("Berhasil!", "Jadwal berhasil disimpan!", "success").then(() => {
        document.getElementById("batalid").click();
      });
      setRefrashaktif(true);

      // Reset form
      setFormData({
        id:"",
        judul:"",
        subjudul:"",
        datetime:"",
        img:"",
        isi:""
      });

    } catch (error) {
      console.error("Terjadi kesalahan:", error);
      Swal.fire("Error!", "Terjadi kesalahan saat menyimpan jadwal.", "error");
    }
  };



  const handleChangeKases = (selectedOptions) => {
    if (!selectedOptions) return;

    // Pastikan `selectedOptions` dalam bentuk array
    const selectedData = selectedOptions;

    setFormData((prevData) => ({
      ...prevData,
      akses: selectedData.value,
    }));

    console.log("Updated Form Data:", formData);
  };



  return (
    <div>
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-xl-12 col-md-12">
              <div className="card">

                <div className="card-body">
                  <div className='row mb-3 align-items-center'>
                    <div className="col"><small className="text-muted">Refrensi</small><h3>Pengumuman</h3></div>

                    <div className='col-auto'>
                      <button data-bs-toggle="modal" data-bs-target="#ujianModal" type="button" className="btn btn-primary"> Pengumuman Baru</button>
                    </div>
                  </div>
                  <hr />
                  {/* Tabel kelas */}
                  <table className="table table-hover datatable-table">
                    <thead>
                      <tr>
                        <th width="10">#</th>
                        <th width="50"><b>Judul</b><br></br> Ringkasan</th>
                        <th width="50">Akses</th>
                        <th width="50"><center>Action</center></th>
                      </tr>
                    </thead>
                    <tbody>

                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Input/Edit */}
      <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog">
          <form onSubmit={handleSubmit} className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{isEditing ? "Edit Kelas" : "Tambah Kelas"}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">


                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="mb-4 w-full file:py-2 file:px-4 file:border file:rounded file:bg-blue-50 file:text-blue-700"
                />



                <button
                  onClick={handleUpload}
                  type='button'
                  className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                >
                  Upload
                </button>
                {!formData.img && preview && <img src={preview} alt="Preview" className="img-fluid" />}
                {progress > 0 && (
                  <div className="mt-4">
                    <div className="text-sm text-gray-500 mb-1">Progress: {progress}%</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                      <div
                        className="bg-blue-600 h-2.5 rounded-full"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                  </div>
                )}

              
                  {formData.img && (
                  <div className="mt-4">
                   <img src={formData.img} alt="Preview" className="img-fluid" />
                   <br></br>
                    <a href={formData.img} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                      Lihat gambar
                    </a>
                  </div>
                )}

              </div>
              <div className="mb-3">
                <label className="form-label">Judul</label>
                <input type="text" className="form-control" name="judul" value={formData.judul} onChange={handleChange} required />

              </div>
              <div className="mb-3">
                <label className="form-label">Ringkasan</label>
                <textarea name="subjudul" onChange={handleChange} value={formData.subjudul} class="form-control" id="exampleFormControlTextarea1" rows="3" required></textarea>

              </div>
              <div className="mb-3">
                <label className="form-label">Akses</label>
                <Select
                  options={akses || []}
                  required
                  name="data_id"
                  getOptionLabel={(e) => e.label} // Menampilkan `nama` di dropdown
                  getOptionValue={(e) => e.value} // Menggunakan `data_id` sebagai value
                  value={akses.find((option) => option.value === formData.akses) || null}
                  onChange={handleChangeKases}
                  placeholder="Pilih Akses..."
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Isi</label>


                <ReactQuill
                  value={formData.isi}
                  onChange={handleChangeisi}
                  theme="snow"
                  required
                  modules={modules}
                  formats={formats}
                  placeholder="Tulis di sini..."
                />

              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" id="batalid" data-bs-dismiss="modal">
                Batal
              </button>
              <button type="onSubmit" className="btn btn-primary"
              >
                {isEditing ? "Update" : "Simpan"}
              </button>
            </div>
          </form>
        </div>
      </div>


    </div>
  );
};

export default Pengumuman;
